import { useLocation } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import { setPreviousUrl } from 'shared/client/previousUrl';

export function RouteChangeTracker() {
  const { pathname, searchStr } = useLocation();
  const previousUrlRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (previousUrlRef.current !== undefined) {
      setPreviousUrl(previousUrlRef.current);
    }
    previousUrlRef.current = window.location.origin + pathname + (searchStr ? `?${searchStr}` : '');
  }, [pathname, searchStr]);

  return null;
}
